import { Control, ControlCodes, getControlName } from "@theprelude/core";
import { jsonStringSchema } from "@/lib/validators";
import { IntegrationForm } from "../integration-form";

const controlCode = ControlCodes.GOOGLE_IDENTITY;
const controlName = getControlName(controlCode);

export const GoogleIdentityIntegrationForm = ({
  instance,
}: {
  instance?: Control;
}) => {
  return (
    <IntegrationForm
      control={controlCode}
      instanceId={instance?.instance_id}
      instanceName={instance?.name ?? undefined}
      description={`Connect to ${controlName}, and get a full view of your users.`}
      fields={{
        credentials: {
          label: "Credentials JSON",
          type: "file",
          placeholder: "Upload your credentials.json",
          required: true,
          validator: jsonStringSchema,
        },
      }}
      transformParams={({ credentials }) => ({
        api: "",
        user: "",
        secret: credentials,
      })}
    />
  );
};
